// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZeGP","type":"styles_type__28N7G","choices":"styles_choices__3Tb_l"};